import type { CSSProperties, ComponentPropsWithRef, ReactNode } from "react";
import { forwardRef } from "react";
import { omit } from "lodash";
import { classNames } from "@/react/helpers/twMergeWithCN";
import type { StyleValue } from "@circle-react-shared/BuilderUI/StyleValue.types";
import { parseSizing } from "@circle-react-shared/BuilderUI/utils/parseSizing";
import { parseStyles } from "@circle-react-shared/BuilderUI/utils/parseStyles";
import { defaultStyles } from "./defaultStyles";

interface StackProps extends Omit<ComponentPropsWithRef<"div">, "style"> {
  children: ReactNode;
  styles?: Readonly<Record<string, StyleValue>>;
}

export const Stack = forwardRef<HTMLDivElement, StackProps>(
  ({ children, styles = {}, className, ...rest }, ref) => {
    const inlineStyles: CSSProperties = {
      ...parseStyles({
        styles: omit(styles, "sizing"),
        defaultStyles,
      }),
      ...parseSizing({
        sizing: styles.sizing,
        defaultSizing: defaultStyles.sizing,
      }),
    };

    return (
      <div
        ref={ref}
        className={classNames(
          "wb-flex wb-p-5 wb-w-full wb-h-auto wb-gap-4 wb-flex-wrap wb-items-center wb-justify-start wb-min-h-24",
          className,
        )}
        style={inlineStyles}
        {...rest}
      >
        {children}
      </div>
    );
  },
);

Stack.displayName = "Stack";
